/** Complete Alta mark without payoff, for the dark-blue login/start surface. */
export default function AltaLoginLogo() {
  return (
    <img
      src="/alta_logo_white.svg"
      alt="Alta"
      width={32 * 425.2 / 94.5}
      height={32}
      style={{ maxWidth: "70vw", width: "auto", height: 32, display: "block" }}
    />
  );
}
